import { Dialog } from '@headlessui/react';
import { Rocket, X } from 'lucide-react';

interface CreatorWelcomeModalProps {
    isOpen: boolean;
    onClose: () => void;
    onContinue: () => void;
}

export default function CreatorWelcomeModal({ isOpen, onClose, onContinue }: CreatorWelcomeModalProps) {
    return (
        <Dialog open={isOpen} onClose={onClose} className="relative z-[110]">
            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
            <div className="fixed inset-0 flex items-center justify-center p-4">
                <Dialog.Panel className="mx-auto w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
                    <div className="flex items-start justify-between">
                        <div className="flex items-center">
                            <div className="h-10 w-10 flex items-center justify-center rounded-full bg-purple-100">
                                <Rocket className="h-6 w-6 text-purple-600" />
                            </div>
                            <Dialog.Title className="ml-3 text-lg font-semibold text-gray-900">
                                Welcome to your Creator Dashboard
                            </Dialog.Title>
                        </div>
                        <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                            <X className="h-5 w-5" />
                        </button>
                    </div>

                    {/* MSF-222 (ported): this still opened with "Required: Set up payouts"
                        after publishing stopped being payment-gated, so the first thing the
                        product said to a creator was a demand that is no longer true.
                        Payouts are the last step now, framed as what they actually are:
                        how the money reaches you once people start giving. */}
                    <div className="mt-4 text-gray-600 text-sm">
                        <p>Your mission page can go live today &mdash; you don't need a bank account to publish it.</p>
                        <ul className="mt-3 list-disc pl-5 space-y-1">
                            <li>Create or update your mission page</li>
                            <li>Post your first update to engage supporters</li>
                            <li>Publish and share it</li>
                            <li>Set up payouts whenever you're ready &mdash; supporters can only give once it's done</li>
                        </ul>
                    </div>

                    <div className="mt-6 flex gap-2">
                        <button onClick={onContinue} className="inline-flex items-center justify-center rounded-md bg-purple-600 px-4 py-2 text-white hover:bg-purple-700 w-full">
                            Set up payouts
                        </button>
                        <button onClick={onClose} className="inline-flex items-center justify-center rounded-md border border-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-50 w-full">
                            Not yet — let me build my page
                        </button>
                    </div>
                </Dialog.Panel>
            </div>
        </Dialog>
    );
}



